import { render, staticRenderFns } from "./BalanceCardSkeleton.vue?vue&type=template&id=bd2db0ce&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports